import { MenuIcon } from '../../common/ui/icons';
import { toggleMobileMenuBodyClass } from './mobile-menu-provider';

const MobileMenuBtn = () => {

    return (
        <button
            onClick={ toggleMobileMenuBodyClass }
            className="absolute right-4 top-4 xl:hidden z-[1000]"
            type="button">
            <MenuIcon />
        </button>
    )
};

export default MobileMenuBtn;